import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { FiCheckCircle, FiX, FiPlus } from "react-icons/fi";
import { createCustomSubscriptionPlan } from "../../redux/services/SubscriptionServices/Subscription.Services";
import { successToast, errorToast } from "../../Utils/toast";
// import { ActiveModuleList } from "../../redux/services/moduleService/module.Services";
import { ActiveCategoryList } from "../../redux/services/categoriesService/categories.Services";
import { closeModal } from "../../redux/features/modalSlice";
function AddPlan() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modalData = useSelector((state) => state.modal?.data);
  console.log("modal data", modalData)
  const isCustomAssign = Boolean(modalData?.vendor_id || modalData?.module_id);
  const isServiceLocked = Boolean(modalData?.module_id);
  const [modules, setModules] = useState([]);
  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    // module_id: "",
    module_id: modalData?.module_id ? String(modalData.module_id) : "",
    payment_method: "cash",
    // category_id: "",
    price: "",
    subscription_type: "custom",
    original_price: "",
    // duration_days: 30,
    ai_call_limit: 0,

    // staff_limit: 0,
    // product_limit: 0,
    // features: [""],
    // is_popular: 0,
    // badge_text: "",

    status: 1,
  });

  // Fetch modules + categories
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const [modulesRes, categoriesRes] = await Promise.all([
  //         ActiveModuleList(),
  //         ActiveCategoryList(),
  //       ]);
  //       setModules(modulesRes?.data || []);
  //       setCategories(categoriesRes?.data || []);
  //     } catch (error) {
  //       console.log("API error:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   if (modalData?.module_id) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       module_id: String(modalData.module_id),
  //     }));
  //   }
  // }, [modalData?.module_id]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  // Sirf digits allow karo (0-9)
  const handleNumericChange = (field, value) => {
    const onlyDigits = value.replace(/\D/g, ""); // non-digits hata do
    handleChange(field, onlyDigits);
  };

  const handleFeatureChange = (index, value) => {
    setFormData((prev) => {
      const features = [...prev.features];
      features[index] = value;
      return { ...prev, features };
    });
  };

  const addFeature = () => {
    setFormData((prev) => ({ ...prev, features: [...prev.features, ""] }));
  };

  const removeFeature = (index) => {
    setFormData((prev) => {
      const features = prev.features.filter((_, i) => i !== index);
      return { ...prev, features: features.length ? features : [""] };
    });
  };

  const validate = () => {
    const err = {};

    if (!formData.name?.trim()) err.name = "Plan name is required";

    // if (!formData.module_id) err.module_id = "Service is required";


    if (formData.price === "" || isNaN(Number(formData.price))) {
      err.price = "Price is required";
    }
    if (
      formData.original_price === "" ||
      isNaN(Number(formData.original_price))
    ) {
      err.original_price = "Original price is required";
    } else if (Number(formData.original_price) <= 0) {
      err.original_price = "Original price must be greater than 0";
    } else if (Number(formData.original_price) < Number(formData.price)) {
      err.original_price = "Original price must be >= price";
    }

    if (
      formData.ai_call_limit === "" ||
      isNaN(Number(formData.ai_call_limit)) ||
      Number(formData.ai_call_limit) <= 0
    ) {
      err.ai_call_limit = "AI Call Limit is required and must be greater than 0";
    }

    // if (!formData.duration_days || Number(formData.duration_days) < 1) {
    //   err.duration_days = "Duration must be at least 1 day";
    // }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setLoading(true);


      const startDate = new Date().toISOString().split("T")[0];
      const nextMonth = new Date();
      nextMonth.setMonth(nextMonth.getMonth() + 1);
      const endDate = nextMonth.toISOString().split("T")[0];
      const finalPrice = Number(formData.price) || Number(formData.original_price) || 0;

      const payload = {
        name: formData.name.trim(),
        description: formData.description?.trim() || "",
        subscription_type: formData.counstom?.trim() || "",
        payment_amount: finalPrice > 0 ? finalPrice : 1,
        vendor_id: modalData?.vendor_id,
        module_id: Number(formData.module_id),
        subscription_type: "custom",
        price: Number(formData.price),
        original_price: formData.original_price
          ? Number(formData.original_price)
          : 0,
        ai_call_limit: Number(formData.ai_call_limit) || 0,

        start_date: startDate,
        end_date: endDate,
        payment_method: formData.payment_method,
        status: Number(formData.status),
      };

      const res = await createCustomSubscriptionPlan(payload);

      if (res?.success !== false) {
        successToast(res?.message || "Plan created successfully");
        dispatch(closeModal());
        navigate("/user-list")
        // navigate("/plan-list");
      } else {
        errorToast(res?.message || "Failed to create plan");
      }
    } catch (error) {
      console.error("Add plan error:", error);
      errorToast(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create plan"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>


      <div className="card-body">
        <form onSubmit={handleSubmit} className="row g-3">
          {/* Plan Name */}
          <div className="col-md-6">
            <label className="form-label fw-bold">
              Plan Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${errors.name ? "is-invalid" : ""}`}
              placeholder="e.g. AI Calling 20000"
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
            {errors.name && (
              <div className="invalid-feedback">{errors.name}</div>
            )}
          </div>
          {/* 
          <div className="col-md-6">
            <label className="form-label fw-bold">
              Service <span className="text-danger">*</span>
            </label>
            <select
              className={`form-control${errors.module_id ? " is-invalid" : ""}`}
              value={formData.module_id}
              onChange={(e) => {
                if (isServiceLocked) return;
                handleChange("module_id", e.target.value);
              }}
              disabled={isServiceLocked}
              style={isServiceLocked ? { background: "#e9ecef" } : {}}
            >
              <option value="">Select Service</option>
              {modules.map((mod) => (
                <option key={mod.id} value={mod.id}>
                  {mod.name}
                </option>
              ))}
            </select>
            {errors.module_id && (
              <div className="invalid-feedback">{errors.module_id}</div>
            )}
          </div> */}

          {/* Category */}
          {/* <div className="col-md-6">
                <label className="form-label fw-bold">
                  Category <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select ${
                    errors.category_id ? "is-invalid" : ""
                  }`}
                  value={formData.category_id}
                  onChange={(e) => handleChange("category_id", e.target.value)}
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
                {errors.category_id && (
                  <div className="invalid-feedback">{errors.category_id}</div>
                )}
              </div> */}





          <div className="col-md-6">
            <label className="form-label fw-bold">Original Price (₹) <span className="text-danger">*</span></label>
            <input
              type="text"
              inputMode="numeric"
              className={`form-control ${errors.original_price ? "is-invalid" : ""}`}
              placeholder="2999"
              value={formData.original_price}
              onChange={(e) =>
                handleNumericChange("original_price", e.target.value)
              }
            />
            {errors.original_price && (
              <div className="invalid-feedback">
                {errors.original_price}
              </div>
            )}
          </div>
          <div className="col-md-6">
            <label className="form-label fw-bold">
              Price (₹) <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              inputMode="numeric"
              className={`form-control ${errors.price ? "is-invalid" : ""}`}
              placeholder="2499"
              value={formData.price}
              onChange={(e) => handleNumericChange("price", e.target.value)}
            />
            {errors.price && (
              <div className="invalid-feedback">{errors.price}</div>
            )}
          </div>

          {/* Sort Order */}
          {/* <div className="col-md-3">
                <label className="form-label fw-bold">Sort Order</label>
                <input
                  type="text"
                  inputMode="numeric"
                  className="form-control"
                  placeholder="5"
                  value={formData.sort_order}
                  onChange={(e) =>
                    handleNumericChange("sort_order", e.target.value)
                  }
                />
              </div> */}

          {/* AI Call Limit */}
          <div className="col-md-6">
            <label className="form-label fw-bold">AI Call Limit <span className="text-danger">*</span></label>
            <input
              type="text"
              inputMode="numeric"
              className={`form-control ${errors.ai_call_limit ? "is-invalid" : ""}`}
              placeholder="20000"
              value={formData.ai_call_limit}
              onChange={(e) =>
                handleNumericChange("ai_call_limit", e.target.value)
              }
            />
            {errors.ai_call_limit && (
              <div className="invalid-feedback">{errors.ai_call_limit}</div>
            )}

          </div>

          {/* <div className="col-md-6">
                <label className="form-label fw-bold">
                  Duration (Days) <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  className={`form-control ${errors.duration_days ? "is-invalid" : ""
                    }`}
                  placeholder="30"
                  value={formData.duration_days}
                  onChange={(e) =>
                    handleNumericChange("duration_days", e.target.value)
                  }
                />
                {errors.duration_days && (
                  <div className="invalid-feedback">
                    {errors.duration_days}
                  </div>
                )}
              </div> */}

          <div className="col-md-6">
            <label className="form-label fw-bold">Status</label>
            <select
              className="form-control"
              value={formData.status}
              onChange={(e) => handleChange("status", e.target.value)}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </div>
          <div className="col-md-12">
            <label className="form-label fw-bold">Description</label>
            <textarea
              rows={2}
              className="form-control"
              placeholder="20000 AI Calls premium plan"
              value={formData.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
          </div>
          <div className="col-12 text-end  pt-3 mt-3">
            <button
              type="button"
              className="btn btn-danger me-2"
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              Cancel
            </button>
            <button type="submit" className="add-btn" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Creating...
                </>
              ) : (
                "Create Custom Plan"
              )}
            </button>
          </div>
        </form>
      </div>


    </>
  );
}

export default AddPlan;